import { nodeListToArray } from '../helpers/nodeListToArray';
import { debounce, assign } from 'lodash';
import { enableTabbableChildren } from '../helpers/enableTabbableChildren';
import { disableTabbableChildren } from '../helpers/disableTabbableChildren';
import '../helpers/closestPolyfill';

let accordionLists;
export interface AccordionsOptions {
    oneOpenAtATime?: boolean;
    accordionTarget?: string;
}
export class Accordion {
    options: AccordionsOptions = {
        oneOpenAtATime: true,
        accordionTarget: '[adage-data-accordion-list]'
    };

    constructor(options?: AccordionsOptions) {
        assign(this.options, options);

        accordionLists = nodeListToArray(document.querySelectorAll(this.options.accordionTarget));

        window.addEventListener(
            'resize',
            debounce(() => {
                this.setAccordionHeights.bind(this);
            }, 50)
        );
        accordionLists.forEach(accordionList => {
            accordionList.addEventListener('click', this.accordionClick.bind(this), false);
            let panels = nodeListToArray(accordionList.querySelectorAll('[aria-hidden]'));
            panels.forEach(panel => {
                disableTabbableChildren(panel);
            });
        });
    }

    setAccordionHeights() {
        accordionLists.forEach(accordionList => {
            let openAccordions = nodeListToArray(accordionList.querySelectorAll('[aria-hidden="false"]'));
            if (openAccordions.length > 0) {
                openAccordions.forEach(openAccordion => {
                    let accordionToSize = openAccordion.querySelector('[data-accordion-content-id]');
                    let accordionNewHeight = accordionToSize.getBoundingClientRect().height;
                    openAccordion.style.height = accordionNewHeight + 'px';
                });
            }
        });
    }

    accordionClick(e) {
        if (e.target !== e.currentTarget) {
            let accordionToOpenId = e.target.getAttribute('aria-controls');
            if (accordionToOpenId === null) {
                accordionToOpenId = e.target.closest('[aria-controls]').getAttribute('aria-controls');
            }
            let accordionToToggle = document.querySelector('#' + accordionToOpenId);
            let accordionContentHeight = document
                .querySelector('[data-accordion-content-id="' + accordionToOpenId + '"]')
                .getBoundingClientRect().height;
            if (this.options.oneOpenAtATime) {
                this.closeOpenAccordions(accordionToToggle);
            }
            if (accordionToToggle.getAttribute('aria-hidden') == 'false') {
                this.closeAccordion(accordionToToggle);
            } else {
                this.openAccordion(accordionToToggle, accordionContentHeight);
            }
            this.setAccordionHeights();
        }
        e.stopPropagation();
    }

    openAccordion(accordionToOpen, accordionToOpenHeight) {
        accordionToOpen.setAttribute('style', 'height:' + accordionToOpenHeight + 'px');
        accordionToOpen.setAttribute('aria-hidden', 'false');
        enableTabbableChildren(accordionToOpen);
        let id = accordionToOpen.id;
        document.querySelector('[aria-controls="' + id + '"]').setAttribute('aria-expanded', 'true');
    }

    closeAccordion(accordionToClose) {
        accordionToClose.setAttribute('style', 'height: 0px');
        accordionToClose.setAttribute('aria-hidden', 'true');
        disableTabbableChildren(accordionToClose);
        let id = accordionToClose.id;
        document.querySelector('[aria-controls="' + id + '"]').setAttribute('aria-expanded', 'false');
    }

    closeOpenAccordions(exception) {
        let container = exception.closest('ul');
        let openAccordions = nodeListToArray(container.querySelectorAll('[aria-hidden="false"]'));
        openAccordions.forEach(openAccordion => {
            if (openAccordion !== exception) {
                this.closeAccordion(openAccordion);
            }
        });
    }
}
